import { IFetchProfileAction, IFetchProfileFailedAction, IFetchProfileSuccessAction, ProfileActionEnum } from '.';
import { IProfile } from '../../services';

export const FetchProfileAction = () => {
    return {
        type: ProfileActionEnum.FetchProfile,
        state: { loading: true },
    } as IFetchProfileAction;
};

export const FetchProfileSuccessAction = (profile: IProfile) => {
    return {
        type: ProfileActionEnum.FetchProfileSuccess,
        state: { loading: false, profile: profile },
    } as IFetchProfileSuccessAction;
};

export const FetchProfileFailedAction = (message: string) => {
    return {
      type: ProfileActionEnum.FetchProfileFailed,
      state: { loading: false, exceptionMessage: message },
    } as IFetchProfileFailedAction;
};


